/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const defaultDesignsDataSchema = z.object({
	feed: z.object({
		id: z.string(),
		organisationId: z.string(),
		name: z.string(),
		document: z.string(),
		thumbnailMediaId: z.string().nullable(),
		thumbnailUrl: z.string().nullable(),
		createdAt: z.iso.datetime(),
		updatedAt: z.iso.datetime(),
	}).nullable(),
	story: z.object({
		id: z.string(),
		organisationId: z.string(),
		name: z.string(),
		document: z.string(),
		thumbnailMediaId: z.string().nullable(),
		thumbnailUrl: z.string().nullable(),
		createdAt: z.iso.datetime(),
		updatedAt: z.iso.datetime(),
	}).nullable(),
})

export type DefaultDesignsDataSchema = z.infer<typeof defaultDesignsDataSchema>
